import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import styles from './RouteBlock.scss'
import { CircleSpinner } from 'common/spinners'
import { Block } from 'features/ride_reports/EditPage/ReportEditor/Block'
import { removeBlock } from 'lib/blockUtils'
import { EditorState } from 'draft-js'
import { LinkRouteDialog, LINK_ROUTE_DIALOG } from './LinkRouteDialog'
import { experienceRoutesSelectors } from 'lib/api/experiences/routes'
import { Distance, Elevation } from 'common/units'
import { urls } from 'lib/urls'
import cx from 'classnames'
import { j } from 'lib/textUtils'

export class _RouteBlock extends React.PureComponent {
  constructor (props) {
    super(props)
    const route = props.block.getData().get('route', null)

    this.state = {
      dialog: route ? null : LINK_ROUTE_DIALOG,
      savePending: false
    }
  }

  componentDidUpdate (prevProps) {
    const { blockProps, block } = this.props
    const { isSelected } = blockProps
    if (!isSelected && !block.getData().get('route')) {
      this.removeSelf()
    }
  }

  save = () => {
  }

  removeSelf = e => {
    e.stopPropagation()
    const { blockProps: { getEditorState, setEditorState }, block } = this.props
    const contentState = getEditorState().getCurrentContent()
    setEditorState(EditorState.push(getEditorState(), removeBlock(contentState, block.getKey()), 'remove-range'))
  }

  chooseRoute = (routeId) => {
    const { blockProps, route } = this.props
    blockProps.onChange({ route: route(parseInt(routeId)) })
    this.setState({ dialog: null })
  }

  render () {
    const { blockProps, block, routes } = this.props
    const { isSelected } = blockProps
    const { dialog } = this.state
    const data = this.props.block.getData()
    const route = data.get('route', null)

    if (!route) {
      return (
        <Fragment>
          <LinkRouteDialog
            routes={routes}
            onSave={this.chooseRoute}
            onRequestClose={this.removeSelf} />
          <Block size='bigBlock' blockProps={blockProps} block={block}>
            <CircleSpinner centered size={80} />
          </Block>
        </Fragment>
      )
    }

    return (
      <Fragment>
        {dialog === LINK_ROUTE_DIALOG && <LinkRouteDialog
          route={route}
          routes={routes}
          onSave={this.chooseRoute}
          onRequestClose={() => this.setState({ dialog: null })} />}
        <Block size='bigBlock' blockProps={blockProps} block={block}>
          <RouteBlockContent
            route={route}
            onClickEdit={() => this.setState({ dialog: LINK_ROUTE_DIALOG })}
            onClickDelete={this.removeSelf}
            isSelected={isSelected} />
        </Block>
      </Fragment>
    )
  }
}

export const RouteBlockContent = ({ route, onClickEdit, onClickDelete, isSelected }) => (
  <div className={cx(styles.blockContainer, isSelected && styles.selected)}>
    <img src={urls.staticMap('route', 'cornea', route.id)} height='88px' width='88px' />
    <div className={styles.details}>
      <h3><a className={styles.routeName}>{route.name}</a></h3>
      <div className={styles.location}>{j([route.locality, route.administrativeArea, route.country])}</div>
      <div className={styles.metrics}>
        <Distance value={route.distance}>
          {m => <Metric metric={m} />}
        </Distance>
        {', '}
        <Elevation value={route.elevationGain}>
          {m => <Metric metric={m} />}
        </Elevation>
      </div>
    </div>
    {isSelected && <div className={styles.ctaWrangler}>
      <a className={styles.cta} link margins={false} onClick={onClickEdit}>Edit</a>
      <a className={styles.cta} link margins={false} onClick={onClickDelete}>Delete</a>
    </div>}
  </div>
)

const Metric = ({ metric }) => (
  <span>
    {metric.valueToString()} {<span>{metric.short}</span>}
  </span>
)

const mapStateToProps = (state, ownProps) => {
  const { experienceId } = ownProps.blockProps.guide

  return {
    routes: experienceRoutesSelectors.routesForExperience(state.routes, experienceId),
    route: (routeId) => state.routes.routes.get(routeId)
  }
}

export const RouteBlock = connect(
  mapStateToProps,
  null
)(_RouteBlock)
